import { Unit } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { getArchivedRequestsQuery } from './get-archived-requests-query';

export const getArchivedRequestsQueryOptions = (date: Date, units: Unit[]) =>
  queryOptions({
    queryKey: [getArchivedRequestsQuery(date, units).className, getArchivedRequestsQuery(date, units).toJSON()],
    queryFn: async () => {
      const query = getArchivedRequestsQuery(date, units);
      return await query.find();
    },
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
    refetchInterval: 60 * 1000 * 5, // 5 minutes
  });
